import styled from '@emotion/styled';
import {colors, fonts, Submit} from 'ui';

export const Container = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '16px',
  backgroundColor: 'white',
  overflow: 'hidden',
  minWidth: 0,
});

export const Img = styled('img')({
  width: 60,
  height: 'auto',
});

export const Title = styled('p')({
  fontSize: 12,
  lineHeight: '14px',
  color: 'black',
  fontFamily: fonts.text,
  fontWeight: 400,
  textAlign: 'left',
  margin: '12px 0',
  height: 42,
  maxHeight: 42,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  width: '100%',
});

export const Points = styled(Submit)({
  marginBottom: 0,
  marginTop: 'auto',
  width: '100%',
  '& span': {
    fontSize: 16,
    padding: '12px 0',
  },
});

export const NewBadge = styled('span')({
  position: 'absolute',
  top: 8,
  right: 8,
  padding: '3px 8px',
  backgroundColor: colors.caramel,
  color: colors.white,
  fontSize: 11,
  fontWeight: 'bold',
  letterSpacing: 0.5,
  textTransform: 'uppercase',
});

export const MoreButton = styled('button')({
  alignSelf: 'flex-start',
  marginBottom: 12,
  padding: 0,
  border: 'none',
  background: 'none',
  color: colors.caramel,
  fontFamily: fonts.default,
  fontSize: 12,
  textDecoration: 'underline',
  cursor: 'pointer',
});

export const Status = styled('p')({
  alignSelf: 'flex-start',
  margin: '0 0 12px',
  color: colors.grey,
  fontFamily: fonts.default,
  fontSize: 12,
  lineHeight: '16px',
});
